export default {"src":"/_next/static/media/ArrowUp.3468de56.svg","height":56,"width":40};